import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconHorizonFolderBlueSizeS from './IconHorizonFolderBlue_size_s';

const props: CreateIconArguments = {
  l: IconHorizonFolderBlueSizeS,
  m: IconHorizonFolderBlueSizeS,
  s: IconHorizonFolderBlueSizeS,
  xs: IconHorizonFolderBlueSizeS,
  name: 'IconHorizonFolderBlue',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
